/*
    TODO: share these more broadly?

    Some, not all, of these styles are seen through-out /account
    and we could share across all account pages.
*/

const styles = {
    section: 'rounded-lg bg-white py-25 px-20 lg:px-30 lg:flex lg:gap-20',
    sectionHeading: 'text-body-lg mb-20 shrink-0 font-grotesk-bold lg:w-[240px]',
    cancel: 'text-body-sm mx-auto mt-15 block link',
    edit: 'text-body-sm link ml-auto lg:mr-40 link',
    editContainer: 'md:w-[350px]',
    displayContainer: 'flex gap-10 grow text-body-md',
};

export default styles;
